import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';
import { HILO_COLORS } from '../../../src/quiz/constants/higherLower.constants';

export const playerStatCardStyles = StyleSheet.create({
  // Natural-feeling card that shares the field's height (flex) but never clips its own content:
  // there is deliberately NO overflow:hidden, so on short phones the avatar/label spill gently
  // rather than being cropped to a half-circle. Corners stay rounded via the gradient's own radius.
  card: {
    flex: 1,
    maxHeight: 210,
    position: 'relative',
    borderRadius: 18,
    // Soft drop shadow (design: 0 4px 16px rgba(0,0,0,.4)).
    shadowColor: HILO_COLORS.cardShadow,
    shadowOpacity: 0.4,
    shadowRadius: 16,
    shadowOffset: { width: 0, height: 4 },
    elevation: 6,
  },
  // The gradient IS the content container (its borderRadius clips the corners); the result badge +
  // flag paint above it. An absolute gradient would overdraw SVG/image children on Android.
  cardInner: {
    flex: 1,
    borderRadius: 18,
    paddingTop: 16,
    paddingBottom: 18,
    paddingHorizontal: 18,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: 'rgba(167,139,250,0.18)',
  },
  cardCorrect: {
    borderColor: WARMUP_COLORS.green,
    borderWidth: 2,
  },
  cardWrong: {
    borderColor: WARMUP_COLORS.danger,
    borderWidth: 2,
  },
  // Result glow (design: 0 0 22px rgba(...)). Recoloured drop shadow on the outer card.
  cardCorrectGlow: { shadowColor: WARMUP_COLORS.green, shadowOpacity: 0.45, shadowRadius: 20 },
  cardWrongGlow: { shadowColor: WARMUP_COLORS.danger, shadowOpacity: 0.45, shadowRadius: 20 },
  badge: {
    position: 'absolute',
    top: 13,
    right: 13,
    width: 28,
    height: 28,
    borderRadius: 9999,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
  },
  badgeCorrect: { backgroundColor: WARMUP_COLORS.green },
  badgeWrong: { backgroundColor: WARMUP_COLORS.danger },
  avatar: {
    width: 52,
    height: 52,
    borderRadius: 9999,
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: HILO_COLORS.cardShadow,
    shadowOpacity: 0.35,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 2 },
    elevation: 4,
  },
  avatarText: {
    fontSize: 18,
    fontWeight: '800',
    color: '#FFFFFF',
  },
  nameRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 7,
    marginTop: 5,
    maxWidth: '100%',
  },
  name: {
    fontSize: 17,
    fontWeight: '800',
    color: WARMUP_COLORS.text,
    letterSpacing: -0.2,
    flexShrink: 1,
  },
  metaRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    marginTop: 5,
  },
  metaPill: {
    fontSize: 11,
    fontWeight: '700',
    color: WARMUP_COLORS.textDim,
    backgroundColor: WARMUP_COLORS.surfaceAlt,
    borderRadius: 9999,
    paddingVertical: 2,
    paddingHorizontal: 8,
    overflow: 'hidden',
  },
  retiredPill: {
    color: WARMUP_COLORS.amber,
    backgroundColor: HILO_COLORS.retiredPillBg,
  },
  club: {
    fontSize: 12,
    fontWeight: '500',
    color: WARMUP_COLORS.textDim,
    marginTop: 3,
    maxWidth: '100%',
  },
  statValue: {
    fontSize: 42,
    fontWeight: '800',
    lineHeight: 44,
    marginTop: 6,
    fontVariant: ['tabular-nums'],
    color: WARMUP_COLORS.text,
  },
  statValueCorrect: { color: WARMUP_COLORS.green },
  statValueWrong: { color: WARMUP_COLORS.danger },
  statLabel: {
    fontSize: 11,
    fontWeight: '800',
    color: WARMUP_COLORS.textFaint,
    letterSpacing: 0.9,
    marginTop: 2,
    textTransform: 'uppercase',
  },
  mystery: {
    fontSize: 42,
    fontWeight: '800',
    lineHeight: 44,
    marginTop: 6,
    color: '#3A3447',
  },
  mysteryHint: {
    fontSize: 11,
    fontWeight: '800',
    color: WARMUP_COLORS.green,
    letterSpacing: 0.6,
    marginTop: 2,
    textTransform: 'uppercase',
  },
});
